import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdventuresService } from '../adventures.service';
import { AdventuresModel } from '../AdventuresModel';
import { AdventureImagesModel } from '../AdventureImagesModel';
import { AdventureIncludedModel } from '../AdventureIncludedModel';
import { AdventureItineraryModel } from '../AdventureItineraryModel';
@Component({
    // moduleId: module.id,
    selector: 'all-adventures',
    templateUrl: 'all-adventures.component.html',
    styleUrls: ['all-adventures.component.scss']
})
export class AllAdventuresComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :AdventuresService,
          private route: ActivatedRoute,
          ) {      this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          this.lang = localStorage.getItem('theme_lang');
          debugger;
          this.modelService.getAll().subscribe(data=>{
              this.rows=data;
              console.log("modelObject",this.rows)
          })
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.adventureImagesList;
              this.includedList=this.modelObject.adventureIncludedList;
              this.itineraryList=this.modelObject.adventureItineraryList;
              console.log("modelObject",this.rows)
            })
  
          }
          else{
          }
  
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: AdventuresModel = new AdventuresModel();
      rows :AdventuresModel[]= [];
      includedList :AdventureIncludedModel[]= [];
      itineraryList :AdventureItineraryModel[]= [];
  
    //   mainForm: FormGroup = new FormGroup({
    //       id: new FormControl(),
    //       images: new FormControl(),
    //       title: new FormControl(),
    //       description: new FormControl(),
    //       latitude: new FormControl(),
    //       longitude: new FormControl(),
    //       countryId: new FormControl(),
    //       cityId: new FormControl(),
    //       userId: new FormControl(),
    //       date: new FormControl(),
    //   });
    
       files:AdventureImagesModel[]=[];
       public picurl: string ='';
       editEnabled = true;

        goBack(){
          this.router.navigate(['/blimp/events']);
        }
        CampDetails(id){
          this.router.navigate(['/camps-details/',id]);
          
        }
  }
  